<template>
  <div class="mt-3" style="font-size: 80%">
    <b-row class="mt-2 mb-4 ml-3 m-r3 ">
      <b-col cols="3">
        <label for="numeroItemClonado" style="color: darkgreen; font-size: 16px;">Número Item Clonado</label>
      </b-col>
      <b-col cols="3">
        <b-form-input
          class="form-control"
          size="sm"
          v-model="numeroItemClonado"
          id="numeroItemClonado"
          rows="1"
        ></b-form-input>
      </b-col>
    </b-row>

    <div class="overflow-auto">
      <b-input-group class="mt-1">
        <b-form-input
          v-model="filter"
          size="sm"
          placeholder="Buscar..."
          class="ml-1 mr-1"
          type="search"
        ></b-form-input>

        <b-pagination
          class="ml-2 mr-2"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="tablaResultados"
          size="sm"
        ></b-pagination>

        <b-form @submit.prevent="obtenerProjects">
          <b-button
            variant="primary"
            type="submit"
            class="btn btn-primary mb-1 mr-1 btn-sm"
          >
            <i class="fas fa-sync"></i>
          </b-button>
        </b-form>
      </b-input-group>

      <b-table
        responsive
        head-variant="light"
        id="tablaResultados"
        :busy="busy"
        :fields="camposTabla"
        :filter="filter"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
        small
        hover
      >
        <template #cell(accion)="row" align="center">
          <b-button-group align="center" size="sm">
            <b-button
              style="width:40px;"
              :disabled="numeroItemClonado == ''"
              variant="outline-success"
              class="mb-2 ml-3 actionButton"
              @click="añadirItem(row.item)"
            >
              <i class="fas fa-plus-circle"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "Proyecto",
  props: ["itemAnyadido"],
  data() {
    return {
      numeroItemClonado: "",
      noIniciado: true,
      enCurso: true,
      terminado: false,
      editando: false,
      disabledCrear: false,
      txtBtnFormulario: "Guardar",
      ClienteContacto: null,
      filter: "",
      id: null,
      nombre: "",
      cif: "",
      busy: false,
      sortBy: "state",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      camposTabla: [
        { key: "numeroOferta", label: "Proyecto - Numero Oferta", sortable: true },
        { key: "accion", label: "", thStyle: { width: "130px" } },
      ],
      msgValue: "",
      items: [],
    };
  },
  methods: {
    async añadirItem(projectadd) {
      if (!this.itemAnyadido) {
        console.error("itemAnyadido está indefinido");
        return;
      }

      // Clonar item y limpiar IDs
      const clonedItem = JSON.parse(JSON.stringify(this.itemAnyadido));
      delete clonedItem.id;

      if (clonedItem.equipoTrabajo) {
        clonedItem.equipoTrabajo.forEach((m) => delete m.id);
      }
      if (clonedItem.avance) {
        clonedItem.avance.forEach((p) => delete p.id);
      }
      if (clonedItem.hitosFacturacion) {
        clonedItem.hitosFacturacion.forEach((h) => delete h.id);
      }
      if (clonedItem.prevision) {
        clonedItem.prevision.forEach((p) => delete p.id);
      }
      if (clonedItem.facturacion) {
        clonedItem.facturacion.forEach((f) => delete f.id);
      }

      // Añadir al proyecto
      if (!projectadd.itemsProject) projectadd.itemsProject = [];
      clonedItem.numeroItem = this.numeroItemClonado;
      projectadd.itemsProject.push(clonedItem);

      try {
        await api1.put(`/api/dekra-projects/v204/project`, projectadd);
        this.numeroItemClonado = "";
        // Si prefieres evitar reload total, emite un evento al padre para refrescar.
        location.reload();
      } catch (error) {
        this.showMsgBoxConfirm(
          (error.response?.data?.message || "Error al actualizar el proyecto") +
            (error.response?.data?.debugMessage ? " - Debug: " + error.response.data.debugMessage : ""),
          "danger",
          "Error"
        );
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      }
    },

    async obtenerProjects() {
      this.busy = true;
      try {
        const { data } = await api1.get(`/api/dekra-projects/v204/project/`, {
          params: {
            noIniciado: this.noIniciado,
            enCurso: this.enCurso,
            terminado: this.terminado,
          },
        });
        this.items = data;
      } catch (error) {
        console.error("Error al obtener los PROYECTOS:", error);
        if ([401, 403].includes(error.response?.status)) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      } finally {
        this.busy = false;
      }
    },

    showMsgBoxConfirm(msg, vari = "danger", title = "Error") {
      this.$bvModal.msgBoxOk(msg, {
        title,
        size: "sm",
        buttonSize: "sm",
        okVariant: vari,
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
    this.obtenerProjects();
  },
};
</script>

<style scoped>
.celdaAccion {
  width: 50px;
}
</style>
